(function documentRRHHAddControllerDefinition() {
    'use strict';

    angular.module('DocumentRRHH')
        .controller('DocumentRRHHAddController', ['$scope', '$stateParams', 'errorsExtend', 'processService', 'configViewService', '$window', '$filter', 'messages', '$translate', 'organizationalUnitService', 'authExtend', '$q', 'fileService',
            function documentRRHHAddController($scope, $stateParams, errors, processService, configViewService, $window, $filter, messages, $translate, organizationalUnitService, authExtend, $q, fileService) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            if (file.name.indexOf(".pdf") > 0) {
                                var index = $scope.getIndexFile(file);
                                if (~index) {
                                    $scope.aux.files[index] = file;
                                } else {
                                    $scope.aux.files.push(file);
                                }
                            }
                        }
                    });

                    $scope.aux.filesTemp = [];
                };

                $scope.getIndexFile = function (fileNew) {
                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        $scope.aux.files.splice(index, 1);
                    }
                };

                $scope.removeEmployeeFile = function (employeeFile) {
                    var index = $scope.employeeFiles.indexOf(employeeFile);
                    if (index > -1) {
                        $scope.employeeFiles.splice(index, 1);
                        $scope.employeeFilesPage.splice(index, 1);
                    }
                };

                $scope.loadViewOptions = function () {
                    if (!$scope.processTypes || $scope.processTypes.length == 0) {
                        $q.all([configViewService.getById("CPPDocumentRRHH"), organizationalUnitService.getRootOf(authExtend.getOrganizationId())]).then(function (result) {
                            var configView = result[0];
                            var rootOu = result[1].filter(function (item) { return item.isRoot })[0];

                            if (configView.processTypes && configView.processTypes.length > 0) {
                                $scope.processTypes = [];

                                angular.forEach(configView.processTypes, function (item) {
                                    if (item.organizationalUnitId == rootOu.id) {
                                        $scope.loadMetadatas(item);
                                    }
                                });

                                if ($scope.processTypes.length === 0) {
                                    errors.showError('DocumentNoCustomProcessType');
                                    $state.go('inicio');
                                }

                                var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                                $scope.processType = found[0] || $scope.processTypes[0];
                            }
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.loadMetadatas = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.createCriteria) {
                            var data = {
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType.toLowerCase(),
                                metadataSystemName: metadata.systemName,
                                metadataIsRequired: metadata.createCriteria.isRequired,
                                metadataLabel: metadata.createCriteria.name,
                                metadataReadOnly: !metadata.createCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.createCriteria.order
                            };

                            processType.metadatas.push(data);
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.selectProcessType = function (processType) {
                    $scope.processType = processType;
                };

                $scope.save = function () {
                    if (!$scope.documentRRHHAdd.$valid) {
                        $scope.documentRRHHAdd.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if ($scope.aux.files.length <= 0) {
                        errors.showError('VerifyFormFile');
                        return false;
                    }

                    if ($scope.employeeFiles.length <= 0) {
                        errors.showError('DocumentVerifyEmployeeFile');
                        return false;
                    }

                    var documents = [];
                    var metadataValues = [];

                    $scope.processType.metadatas.forEach(function (meta) {
                        metadataValues.push({ systemName: meta.metadataSystemName, value: meta.metadataValue });
                    });

                    $scope.employeeFiles.forEach(function (employeeFile) {
                        var metadataValues = []

                        $scope.processType.metadatas.forEach(function (meta) {
                            metadataValues.push({ systemName: meta.metadataSystemName, value: meta.metadataValue });
                        });

                        metadataValues.push({ systemName: '_nroleg', value: employeeFile.metadata[0] });
                        metadataValues.push({ systemName: '_leido', value: 'N' });

                        documents.push({
                            processTypeId: $scope.processType.id,
                            from: 'RRHHDocumentos',
                            organizationalUnitId: employeeFile.organizationalUnitId,
                            metadataValues: metadataValues
                        });
                    });

                    return processService.createBatch(documents, $scope.aux.files, true).then(function (result) {
                        messages.showSuccess('DocumentEmployeeFileSuccess', 'ErrorSuccessTitle', { data: { success: result.data, total: documents.length * $scope.aux.files.length } }).then(function () {
                            $window.history.back();
                        });
                    }, function (error) {
                        errors.showError(error);
                        $window.history.back();
                    });
                };

                $scope.load = function () {
                    $scope.employeeFiles = $stateParams.employeeFiles;
                    $scope.accordionStatus = true;
                    $scope.employeeFilesPage = [];
                    $scope.headers = $stateParams.headers.map(function (h) { return h.label; });
                    $scope.aux = {
                        files: [],
                        filesTemp: [],
                        metadataReplicate: []
                    };

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 8,
                        from: 0
                    };

                    $scope.loadViewOptions();
                };

                $scope.load();

                $scope.setPagingData = function () {
                    var page = $scope.data.currentPage;
                    $scope.data.totalItems = $scope.employeeFiles.length;
                    $scope.data.from = 1 + ($scope.data.itemsPerPage * (page - 1));

                    var pagedData = $scope.employeeFiles.slice(
                        (page - 1) * $scope.data.itemsPerPage,
                        page * $scope.data.itemsPerPage
                    );

                    $scope.employeeFilesPage = pagedData;
                };

                $scope.$watchCollection("employeeFiles", function () {
                    $scope.setPagingData();
                });
            }
        ]);
})();
